import * as Sentry from '@sentry/react';
import { Integration } from '@sentry/types';

const getIntegrations = ({
    replaysOnErrorSampleRate,
    jsBuildFilterKey,
    tracesSampleRate,
}: {
    replaysOnErrorSampleRate?: number;
    jsBuildFilterKey?: string;
    tracesSampleRate?: number;
}): Integration[] => {
    const integrations = [
        Sentry.breadcrumbsIntegration({
            console: false,
            dom: true,
            fetch: false,
            history: true,
            xhr: true,
        }),
        Sentry.extraErrorDataIntegration(),
        Sentry.sessionTimingIntegration(),
    ] as Integration[];

    if (jsBuildFilterKey) {
        integrations.push(
            Sentry.thirdPartyErrorFilterIntegration({
                filterKeys: [jsBuildFilterKey],
                behaviour: 'apply-tag-if-exclusively-contains-third-party-frames',
            })
        );
    }

    if (tracesSampleRate && tracesSampleRate > 0) {
        integrations.push(Sentry.browserTracingIntegration());
    }

    if (replaysOnErrorSampleRate && replaysOnErrorSampleRate > 0) {
        integrations.push(Sentry.replayIntegration());
    }

    return integrations;
};

export default getIntegrations;
